module.exports = __webpack_public_path__ + "components/PromotionalBanner/graphic-signup-welcome.png";